import { useState, useMemo, useCallback } from "react";

// Hook de ordenação genérico para tabelas. `getVal(row, key)` extrai o valor da
// coluna `key` de uma linha. Clique no cabeçalho alterna asc/desc (e troca de coluna).
// Comparação: números numéricos; strings via localeCompare pt-BR com numeric.
export function useSortable(rows, getVal, initial = { key: null, dir: "asc" }) {
  const [sort, setSort] = useState(initial);

  const toggle = useCallback(
    key => setSort(s => (s.key === key ? { key, dir: s.dir === "asc" ? "desc" : "asc" } : { key, dir: "asc" })),
    []
  );

  const sorted = useMemo(() => {
    if (!sort.key) return rows;
    const arr = [...rows];
    arr.sort((a, b) => {
      const va = getVal(a, sort.key);
      const vb = getVal(b, sort.key);
      let c;
      if (va == null && vb == null) c = 0;
      else if (va == null) c = -1;
      else if (vb == null) c = 1;
      else if (typeof va === "number" && typeof vb === "number") c = va - vb;
      else c = String(va).localeCompare(String(vb), "pt-BR", { numeric: true, sensitivity: "base" });
      return sort.dir === "asc" ? c : -c;
    });
    return arr;
    // getVal deve ser estável (definido fora do componente); rows/sort disparam o re-sort
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rows, sort]);

  return { sorted, sort, toggle };
}

export default useSortable;
